export function _scrollTo(destination, offset = 0, duration = 200, easing = 'linear', callback) {

	const easings = {
		linear(t) {
			return t;
		},
		easeInQuad(t) {
			return t * t;
		},
		easeOutQuad(t) {
			return t * (2 - t);
		},
		easeInOutQuad(t) {
			return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
		},
		easeInCubic(t) {
			return t * t * t;
		},
		easeOutCubic(t) {
			return (--t) * t * t + 1;
		},
		easeInOutCubic(t) {
			return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
		},
		easeInQuart(t) {
			return t * t * t * t;
		},
		easeOutQuart(t) {
			return 1 - (--t) * t * t * t;
		},
		easeInOutQuart(t) {
			return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
		},
		easeInQuint(t) {
			return t * t * t * t * t;
		},
		easeOutQuint(t) {
			return 1 + (--t) * t * t * t * t;
		},
		easeInOutQuint(t) {
			return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
		}
	};
	const getOffsetTop = element => {
		let offsetTop = 0;
		while (element) {
			offsetTop += element.offsetTop;
			element = element.offsetParent;
		}
		return offsetTop;
	}

	const start = window.pageYOffset;
	const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

	const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
	const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
	let destinationOffset = typeof destination === 'number' ? destination : getOffsetTop(destination) + offset;
	if (destinationOffset < 0) {
		destinationOffset = 0;
	}
	const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);


	if (!('requestAnimationFrame' in window)) {
		window.scroll(0, destinationOffsetToScroll);
		if (callback) {
			callback();
		}
		return;
	}

	function scroll() {
		const now = 'now' in window.performance ? performance.now() : new Date().getTime();
		const time = Math.min(1, ((now - startTime) / duration));
		const timeFunction = easings[easing](time);
		window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

		if (Math.round(window.pageYOffset) === destinationOffsetToScroll) {
			if (callback) {
				callback();
			}
			return;
		}

		requestAnimationFrame(scroll);
	}

	scroll();
}

export function _scrollToLeft(container, rangeInPixels, duration) {
	/**
	 * @param callbackObj Object An object with callbacks in .start, .progress, and .done
	 * @param duration Integer Total duration in seconds
	 */
	function animate(callbackObj, duration) {
		const requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame;
		let startTime = 0, percentage = 0, animationTime = 0;

		duration = duration * 1000 || 1000;
		const animation = function (timestamp) {

			if (startTime === 0) {
				startTime = timestamp;
			} else {
				animationTime = timestamp - startTime;
			}

			if (typeof callbackObj.start === 'function' && startTime === timestamp) {
				callbackObj.start();

				requestAnimationFrame(animation);
			} else if (animationTime < duration) {

				if (typeof callbackObj.progress === 'function') {
					percentage = animationTime / duration;
					callbackObj.progress(percentage);
				}

				requestAnimationFrame(animation);
			} else if (typeof callbackObj.done === 'function') {
				callbackObj.done();
			}
		};
		return requestAnimationFrame(animation);
	}


	function sideScroll(container, rangeInPixelsInner, duration) {
		const element = container;
		if (element) {
			let sequenceObj = {};
			const seconds = duration;
			const startingScrollPosition = element.scrollLeft;
			sequenceObj.progress = (function (percentage) {

				element.scroll(rangeInPixelsInner - (startingScrollPosition * percentage), 0);
			});

			animate(sequenceObj, seconds);
		}
	}

	sideScroll(container, rangeInPixels, duration);
}

export default class HelperAnimation {
	static scrollTo(destination, offset = 0, duration = 200, easing = 'linear', callback) {
		return _scrollTo(destination, offset, duration, easing, callback);
	}

	static scrollToLeft(container, rangeInPixels, duration) {
		_scrollToLeft(container, rangeInPixels, duration);
	}
}

